module.exports = __webpack_public_path__ + "img/Mockup cedula posterior.7642ed3d.svg";